import { render, staticRenderFns } from "./Regular.vue?vue&type=template&id=6708abb0&"
import script from "./Regular.vue?vue&type=script&lang=ts&"
export * from "./Regular.vue?vue&type=script&lang=ts&"
import style0 from "./Regular.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports